module.exports = __webpack_public_path__ + "static/media/landscape11.d7682669.jpg";